var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"d-show-out-screen"},[_c('div',{ref:"originalContent"},[_vm._t("content")],2),_vm._v(" "),_c('div',{ref:"duplicateContent",staticClass:"duplicate-content",class:{ 'shown': _vm.isShown }},[_vm._t("content")],2)])
}
var staticRenderFns = []

export { render, staticRenderFns }